import assignTask from './assignTaskSaga';
import claimTask from './claimTaskSaga';
import updateTask from './updateTaskSaga';
import completeTask from './completeTaskSaga';

export default [assignTask, claimTask, completeTask, updateTask];
